<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="flowNewAuditForm" :model="formData" class="full-width-input" :disable="readOnly" :rules="rules"
       style="width: 100%;"
      label-width="120px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="信息类别" prop="SysNews.infoType">
            <el-radio-group class="input-item" v-if="!readOnly" v-model="formData.SysNews.infoType"
              @change="onInfoTypeValueChange"
            >
              <el-radio v-for="item in flowNewAuditForm.infoType.impl.dropdownList" :key="item.id"
                :label="item.id"
              >
                {{item.name}}
              </el-radio>
            </el-radio-group>
            <span class="input-item input-label" v-else>{{(formData.SysNews.infoTypeDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="主题" prop="SysNews.subjectName">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.SysNews.subjectName"
              :clearable="true" placeholder="主题"
            />
            <span class="input-item input-label" v-else>{{formData.SysNews.subjectName}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="内容" prop="SysNews.contentInfo">
            <rich-editor ref="contentInfo" class="input-item" v-if="!readOnly" v-model="formData.SysNews.contentInfo" />
            <div class="input-item" v-else v-html="formData.SysNews.contentInfo" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="封面" prop="SysNews.coverImages">
            <el-upload v-if="!readOnly"
                       class="upload-image" name="uploadFile" :headers="getUploadHeaders"
                       :action="getUploadActionUrl('/admin/app/sysNews/upload')"
                       :data="{fieldName: 'coverImages', asImage: true}"
                       :on-success="onCoverImagesUploadSuccess"
                       :on-remove="onCoverImagesRemoveFile"
                       :before-upload="pictureFile"
                       :on-error="onUploadError"
                       list-type="picture"
                       :on-preview="handlePreview"
                       :on-exceed="onUploadLimit"
                       :limit="flowNewAuditForm.coverImages.impl.maxCount"
                       :file-list="flowNewAuditForm.coverImages.impl.fileList"
                       :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
<!--              <div v-if="flowNewAuditForm.coverImages.impl.fileList && flowNewAuditForm.coverImages.impl.fileList[0] != null" style="position: relative">-->
<!--                <img class="upload-image-show"-->
<!--                     :src="flowNewAuditForm.coverImages.impl.fileList[0].url" />-->
<!--                <div class="upload-img-del el-icon-close"-->
<!--                     @click.stop="onCoverImagesRemoveFile(null, null)" />-->
<!--              </div>-->
<!--              <i v-else class="el-icon-plus upload-image-item"></i>-->
            </el-upload>
            <template v-else>
              <el-image v-for="item in parseUploadData(formData.SysNews.coverImages, {id: formData.SysNews.id,
                  fieldName: 'coverImages', asImage: true})"
                        :preview-src-list="getPictureList(formData.SysNews.coverImages, {id: formData.SysNews.id, fieldName: 'coverImages', asImage: true})"
                        class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
<!--            <template v-else>-->
<!--              <img v-for="item in flowNewAuditForm.coverImages.impl.fileList" :key="item.url"-->
<!--                   class="table-cell-image" :src="item.url" />-->
<!--            </template>-->
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="首页展示" prop="SysNews.indexFlag">
            <el-radio-group class="input-item" v-if="!readOnly" v-model="formData.SysNews.indexFlag"
                            @change="onIndexFlagValueChange"
            >
              <el-radio v-for="item in flowNewAuditForm.indexFlag.impl.dropdownList" :key="item.id"
                        :label="item.id"
              >
                {{item.name}}
              </el-radio>
            </el-radio-group>
            <span class="input-item input-label" v-else>{{(formData.SysNews.indexFlagDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="附件" prop="SysNews.attachedFiles">
            <el-upload v-if="!readOnly" name="uploadFile" :headers="getUploadHeaders" multiple
              :action="getUploadActionUrl('/admin/app/sysNews/upload')"
              :data="{fieldName: 'attachedFiles', asImage: false}"
              :on-success="onAttachedFilesUploadSuccess"
              :on-remove="onAttachedFilesRemoveFile"
              :on-error="onUploadError" :on-exceed="onUploadLimit"
              :limit="flowNewAuditForm.attachedFiles.impl.maxCount"
              :file-list="flowNewAuditForm.attachedFiles.impl.fileList"
              :show-file-list="false">
              <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>
            </el-upload>
            <div v-if="flowNewAuditForm.attachedFiles.impl.fileList && flowNewAuditForm.attachedFiles.impl.fileList[0] != null" style="position: relative">
              <div v-for="(item,index) in flowNewAuditForm.attachedFiles.impl.fileList" :key="item.url"
                   style="display:flex;margin-top: 5px;">
                <div> {{item.name}}</div>
                <div style="margin-left: 15px;display: inline-flex">

                  <el-button type="primary" @click="downloadFile(item.url, item.name)">下载</el-button>
                  <el-button type="primary" @click="previewFile(item.url, item.filename)">预览</el-button>
                  <el-button type="primary" v-if="!readOnly"
                             @click="deleteAttachedFiles(item,flowNewAuditForm.attachedFiles.impl.fileList,index)">删除</el-button>
                </div>

              </div>
            </div>
            <template v-else>
              <a v-for="item in flowNewAuditForm.attachedFiles.impl.fileList" :key="item.url"
                href="javascript:void(0);" @click="downloadFile(item.url, item.name)">
                {{item.name}}
              </a>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
import flowMixins from '../../mixins/flowMixins.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { SysNewsController, DictionaryController } from '@/api';
import { FlowOperationController } from '@/api/flowController.js';

const processDefinitionKey = 'flowNewsAudit';

export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')

  },
  name: 'flowNewsAuditForm',
  props: {
    // 是否运行时任务
    isRuntimeTask: {
      type: [Boolean, String]
    },
    // 是否草稿
    isDraft: {
      type: [Boolean, String],
      default: false
    },
    // 是否只读
    readOnly: {
      type: Boolean,
      default: false
    },
    // 流程实例id
    processInstanceId: {
      type: String
    },
    // 抄送消息id
    messageId: {
      type: String
    },
    // 当前任务实例id
    taskId: {
      type: String
    },
    // 任务变量列表
    taskVariableList: {
      type: Array
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, flowMixins],
  data () {
    return {
      fit: 'scale-down',
      imgViewerVisible: false,
      imgList: [],
      formData: {
        SysNews: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          infoType: undefined,
          subjectName: undefined,
          contentInfo: undefined,
          auditStatus: undefined,
          upFlag: undefined,
          attachedFiles: undefined,
          indexFlag: undefined,
          isDatasourceInit: false,
          coverImages: undefined

        }
      },
      rules: {
        'SysNews.infoType': [
          {required: true, message: '请选择信息类型', trigger: 'change'}
        ],
        'SysNews.subjectName': [
          {required: true, message: '请输入主题', trigger: 'change'}
        ],
        'SysNews.contentInfo': [
          {required: true, message: '请输入内容', trigger: 'change'}
        ]
        // 'Budget.budgetType': [
        //   {required: true, message: '请选择预算类型', trigger: 'blur'}
        // ]
      },
      // 保存草稿后返回的taskId
      draftTaskId: undefined,
      // 保存草稿后返回的流程实例ID
      draftProcessInstanceId: undefined,
      flowNewAuditForm: {
        formFilter: {
        },
        formFilterCopy: {
        },
        infoType: {
          impl: new DropdownWidget(this.loadInfoTypeDropdownList)
        },
        coverImages: {
          impl: new UploadWidget(1)
        },
        indexFlag: {
          impl: new DropdownWidget(this.loadIndexFlagDropdownList)
        },
        attachedFiles: {
          impl: new UploadWidget(5)
        },
        isInit: false
      }
    }
  },
  methods: {
    // 启动流程
    handlerStart (operation, copyItemList) {
      // 启动并保存草稿后再次提交
      if (this.draftProcessInstanceId != null && this.draftTaskId != null) {
        return this.handlerOperation(operation, copyItemList);
      }
      return new Promise((resolve, reject) => {
        this.$refs.flowNewAuditForm.validate(valid => {
          if (!valid) return reject();
          this.preHandlerOperation(operation, true).then(res => {
            let formData = this.getMasterData(operation.type, (res || {}).assignee);
            return SysNewsController.startAndTakeUserTaskFlowNewsAudit(this, {
              processDefinitionKey: processDefinitionKey,
              taskVariableData: {
                ...formData.taskVariableData,
                latestApprovalStatus: operation.latestApprovalStatus
              },
              flowTaskCommentDto: {
                approvalType: operation.type
              },
              sysNewsDto: {
                ...formData.masterData
              },
              ...formData.relationData,
              copyData: (copyItemList || []).reduce((retObj, item) => {
                retObj[item.type] = item.id;
                return retObj;
              }, {})
            });
          }).then(res => {
            this.$message.success('启动成功！');
            resolve();
          }).catch(e => {
            reject(e);
          });
        });
      });
    },
    // 流程操作
    handlerOperation (operation, copyItemList) {
      return new Promise((resolve, reject) => {
        this.$refs.flowNewAuditForm.validate(valid => {
          if (!valid) return reject();
          this.preHandlerOperation(operation, this.isDraft).then(res => {
            // 加签、减签操作
            if (operation.type === this.SysFlowTaskOperationType.CO_SIGN || operation.type === this.SysFlowTaskOperationType.SIGN_REDUCTION) {
              return this.submitConsign((res || {}).assignee, operation.type === this.SysFlowTaskOperationType.CO_SIGN);
            }
            // 驳回操作
            if (operation.type === this.SysFlowTaskOperationType.REJECT || operation.type === this.SysFlowTaskOperationType.REJECT_TO_TASK) {
              return FlowOperationController.rejectRuntimeTask(this, {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                targetTaskKey: (res || {}).targetTaskKey,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 驳回到起点
            if (operation.type === this.SysFlowTaskOperationType.REJECT_TO_START) {
              return FlowOperationController.rejectToStartUserTask(this, {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 撤销操作
            if (operation.type === this.SysFlowTaskOperationType.REVOKE) {
              return FlowOperationController.revokeHistoricTask(this, {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                taskComment: '任务处理人撤销任务',
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            let formData = this.getMasterData(operation.type, (res || {}).assignee);
            let params = {
              taskId: this.taskId || this.draftTaskId,
              processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
              flowTaskCommentDto: {
                taskComment: (res || {}).message,
                approvalType: operation.type,
                delegateAssginee: operation.type === this.SysFlowTaskOperationType.TRANSFER ? (res || {}).assignee : undefined
              },
              taskVariableData: {
                ...formData.taskVariableData,
                latestApprovalStatus: operation.latestApprovalStatus
              },
              copyData: (copyItemList || []).reduce((retObj, item) => {
                retObj[item.type] = item.id;
                return retObj;
              }, {})
            }
            // 非只读状态下，提交修改数据
            if (!this.readOnly) {
              // 主表数据
              params.sysNewsDto = {
                ...formData.masterData
              };
              // 关联数据
              params = {
                ...params,
                ...formData.relationData
              };
            }

            return SysNewsController.submitUserTaskFlowNewsAudit(this, params);
          }).then(res => {
            this.reloadMessage(this);
            if (operation.type !== this.SysFlowTaskOperationType.CO_SIGN && operation.type !== this.SysFlowTaskOperationType.SIGN_REDUCTION) {
              this.$message.success(operation.label + '成功！');
            }
            resolve();
          }).catch(e => {
            console.log(e);
          });
        });
      });
    },
    // 保存草稿
    handlerDraft () {
      return new Promise((resolve, reject) => {
        let formData = this.getFormDataImpl();
        let params = {
          processDefinitionKey: processDefinitionKey,
          processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
          sysNewsDto: {
            ...formData.masterData
          },
          ...formData.relationData
        }
        SysNewsController.startAndSaveDraftFlowNewsAudit(this, params).then(res => {
          this.$message.success('草稿保存成功！');
          this.draftProcessInstanceId = res.data.processInstanceId;
          this.draftTaskId = res.data.taskId;
          resolve();
        }).catch(e => {
          reject(e);
        });
      });
    },
    // 获取表单数据
    getFormDataImpl () {
      // 一对一、一对多、多对多关联数据
      let relationData = {};

      return {
        masterData: {
          ...this.formData.SysNews
        },
        relationData: relationData
      }
    },
    // 获取流程表单数据
    getMasterData (operationType, assignee) {
      let taskVariableData;
      if (Array.isArray(this.taskVariableList) && this.taskVariableList.length > 0) {
        taskVariableData = this.taskVariableList.reduce((retObj, item) => {
          retObj[item.variableName] = this.formData.SysNews[item.variableName];
          return retObj;
        }, {});
      }
      // 会签操作设置多实例处理人集合
      assignee = (assignee && assignee !== '') ? assignee.split(',') : undefined;
      if (operationType === this.SysFlowTaskOperationType.MULTI_SIGN) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.assigneeList = assignee;
      } else if (operationType === this.SysFlowTaskOperationType.SET_ASSIGNEE) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.appointedAssignee = Array.isArray(assignee) ? assignee[0] : undefined;
      }

      return {
        ...this.getFormDataImpl(),
        taskVariableData
      }
    },
    // 初始化流程表单
    initFormData () {
      if (!this.isStartFlow) {
        // 流程办理
        let params = {
          processInstanceId: this.processInstanceId,
          taskId: this.taskId
        }
        let httpCall = null;
        if (this.isDraft || this.isDraft === 'true') {
          // 草稿数据
          httpCall = FlowOperationController.viewDraftData(this, {
            processDefinitionKey: processDefinitionKey,
            processInstanceId: this.processInstanceId
          });
        } else if (this.messageId != null) {
          // 抄送消息
          httpCall = FlowOperationController.viewCopyBusinessData(this, {
            messageId: this.messageId
          });
        } else {
          httpCall = (this.taskId && this.isRuntime) ? SysNewsController.viewTaskBusinessDataFlowNewsAudit(this, params) : SysNewsController.viewHistoricTaskBusinessDataFlowNewsAudit(this, params)
        }
        httpCall.then(res => {
          this.formData.SysNews = { ...res.data };
          this.flowNewAuditForm.infoType.impl.onVisibleChange(true).catch(e => {});
          this.flowNewAuditForm.indexFlag.impl.onVisibleChange(true).catch(e => {});
          let attachedFilesDownloadParams = {
            id: this.formData.SysNews.id,
            fieldName: 'attachedFiles',
            asImage: false
          }
          this.flowNewAuditForm.attachedFiles.impl.fileList = this.parseUploadData(this.formData.SysNews.attachedFiles, attachedFilesDownloadParams);

          let coverImagesDownloadParams = {
            id: this.formData.SysNews.id,
            fieldName: 'coverImages',
            asImage: true
          }
          this.flowNewAuditForm.coverImages.impl.fileList = this.parseUploadData(this.formData.SysNews.coverImages, coverImagesDownloadParams);
          // 获取一对多、多对多数据

          // 获取一对多、多对多数据
          this.refreshFlowNewAuditForm(true);
        }).catch(e => {});
      } else {
        // 启动流程
        this.flowNewAuditForm.infoType.impl.onVisibleChange(true).catch(e => {});
        this.flowNewAuditForm.indexFlag.impl.onVisibleChange(true).catch(e => {});
      }
    },
    onCancel (isSuccess) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess);
      }
    },
    /**
     * 首页展示选中值改变
     */
    onIndexFlagValueChange (value) {
    },
    /**
     * 信息类别下拉数据获取函数
     */
    loadInfoTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictInfoTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 信息类别下拉数据获取函数
     */
    loadIndexFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYesOrNoDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 信息类别选中值改变
     */
    onInfoTypeValueChange (value) {
    },
    /**
     * 更新内容审核表单
     */
    refreshFlowNewAuditForm (reloadData = false) {
      if (!this.flowNewAuditForm.isInit) {
        // 初始化下拉数据
        this.flowNewAuditForm.infoType.impl.onVisibleChange(true).catch(e => {});
        this.flowNewAuditForm.indexFlag.impl.onVisibleChange(true).catch(e => {});
      }
      this.flowNewAuditForm.isInit = true;
    },
    /**
     * 附件上传成功
     */
    onAttachedFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.flowNewAuditForm.attachedFiles.impl.onFileChange(file, fileList);
        this.formData.SysNews.attachedFiles = this.fileListToJson(this.flowNewAuditForm.attachedFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除附件
     */
    onAttachedFilesRemoveFile (file, fileList) {
      this.flowNewAuditForm.attachedFiles.impl.onFileChange(file, fileList);
      this.formData.SysNews.attachedFiles = this.fileListToJson(this.flowNewAuditForm.attachedFiles.impl.fileList);
    },
    deleteAttachedFiles (file, fileList, index) {
      fileList.splice(index, 1)
      this.onAttachedFilesRemoveFile(file, fileList)
    },
    onCoverImagesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.flowNewAuditForm.coverImages.impl.onFileChange(file, fileList);
        this.formData.SysNews.coverImages = this.fileListToJson(this.flowNewAuditForm.coverImages.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除封面
     */
    onCoverImagesRemoveFile (file, fileList) {
      this.flowNewAuditForm.coverImages.impl.onFileChange(file, fileList);
      this.formData.SysNews.coverImages = this.fileListToJson(this.flowNewAuditForm.coverImages.impl.fileList);
    },
    closeImgViewer () {
      this.imgViewerVisible = false;
    },
    handlePreview (file) {
      this.imgViewerVisible = true
      this.imgList = []
      this.imgList.push(file.url)
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    formInit () {
      this.initFormData();
    },
    ...mapActions(['reloadMessage'])
  },
  computed: {
    isStartFlow () {
      return this.processInstanceId == null;
    },
    isRuntime () {
      return typeof this.isRuntimeTask === 'string' ? this.isRuntimeTask === 'true' : this.isRuntimeTask;
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  }
}
</script>
